
import UMUM from "../../library/umum.js";
export default {
   data() {
      return {
         UMUM: UMUM,
         isPwd: true,
         isPwd2: true,

         form: {
            id: null,
            nama_lengkap: '',
            nik: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            golongan_darah: '',
            rhesus: '',
            kabupaten_id: null,
            kecamatan_id: null,
            des_kel_id: null,
            alamat: '',
            email: '',
            no_hp: '',
            riwayat_penyakit: null,
            terakhir_donor: null,
            foto_profil: null,
            dokumen_pendukung: null,
            foto_profil_url: '',
            dokumen_pendukung_url: '',
            stokdarah_konut: 4,
            bersedia_dipublikasikan: true,
         },
         kabupatenOptions: [],
         kecamatanOptions: [],
         deskelOptions: [],

         mdl_add: false,
         mdl_edit: false,
         mdl_hapus: false,
         btn_add: false,
         btn_edit: false,
         btn_hapus: false,

         list_data: [],
         jml_data: 0,
         total_data: 0,
         page_first: 1,
         page_last: 0,
         page_limit: 10,
         cari_value: '',

         mdl_riwayat: false,
         currentPendonor: {},
         riwayatList: [],
         riwayatLoading: false,


         errorMessage: '',
         mdl_lihat: false,
         lihatData: {
            nama_lengkap: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            golongan_darah: '',
            rhesus: '',
            email: '',
            no_hp: '',
            alamat: '',
            riwayat_penyakit: '',
            terakhir_donor: '',
            kabupaten_nama: '',
            kecamatan_nama: '',
            des_kel_nama: '',
            foto_profil: '',
            dokumen_pendukung: '',
            id: '',
         },
      }
   },
   computed: {
      file_path() {
         return this.$store.state.url.URL_APP + "uploads/";
      }
   },
   watch: {
      'form.kabupaten_id'(newVal) {
         this.form.kecamatan_id = null;
         this.form.des_kel_id = null;
         this.kecamatanOptions = [];
         this.deskelOptions = [];
         if (newVal) {
            this.loadKecamatan(newVal);
         }
      },
      'form.kecamatan_id'(newVal) {
         this.form.des_kel_id = null;
         this.deskelOptions = [];
         if (newVal) {
            this.loadDeskel(newVal);
         }
      }
   },
   methods: {
      loadKabupaten() {
         fetch(this.$store.state.url.REGIS_DONOR + "kabupaten")
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.kabupatenOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data kabupaten' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat kabupaten' });
            });
      },
      loadKecamatan(kabupatenId) {
         fetch(`${this.$store.state.url.REGIS_DONOR}kecamatan?kabupaten_id=${kabupatenId}`)
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.kecamatanOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data kecamatan' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat kecamatan' });
            });
      },
      loadDeskel(kecamatanId) {
         fetch(`${this.$store.state.url.REGIS_DONOR}deskel?kecamatan_id=${kecamatanId}`)
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.deskelOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data desa/kelurahan' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat desa/kelurahan' });
            });
      },


      getView() {
         const body = {
            page_limit: this.page_limit,
            data_ke: (this.page_first - 1) * this.page_limit,
            cari_value: this.cari_value,
         };

         fetch(this.$store.state.url.REGIS_DONOR + "getview", {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
         })
            .then(res => res.json())
            .then(res_data => {
               if (res_data.success) {
                  this.list_data = res_data.data;
                  this.jml_data = res_data.jml_data;
                  this.total_data = res_data.total_data;
                  this.page_last = Math.ceil(this.total_data / this.page_limit);
               } else {
                  this.$q.notify({ type: "negative", message: res_data.message || "Gagal mengambil data" });
               }
            })
            .catch(err => {
               console.error("Error fetching data:", err);
               this.$q.notify({ type: "negative", message: "Gagal mengambil data pendonor" });
            });
      },

      async addData() {
         try {




            this.btn_add = true;

            const formData = new FormData();
            formData.append('nama_lengkap', this.form.nama_lengkap);
            formData.append('nik', this.form.nik);
            formData.append('tanggal_lahir', this.form.tanggal_lahir);
            formData.append('jenis_kelamin', this.form.jenis_kelamin);
            formData.append('golongan_darah', this.form.golongan_darah);
            formData.append('rhesus', this.form.rhesus || '');
            formData.append('kabupaten_id', this.form.kabupaten_id || '');
            formData.append('kecamatan_id', this.form.kecamatan_id || '');
            formData.append('des_kel_id', this.form.des_kel_id || '');
            formData.append('alamat', this.form.alamat || '');
            formData.append('email', this.form.email || '');
            formData.append('no_hp', this.form.no_hp || '');
            formData.append('riwayat_penyakit', this.form.riwayat_penyakit || '');
            formData.append('terakhir_donor', this.form.terakhir_donor || '');
            formData.append('stokdarah_konut', this.form.stokdarah_konut || 4);
            formData.append('bersedia_dipublikasikan', 1);

            // Append file
            if (this.form.foto_profil && this.form.foto_profil instanceof File) {
               formData.append('foto_profil', this.form.foto_profil);
            }
            if (this.form.dokumen_pendukung && this.form.dokumen_pendukung instanceof File) {
               formData.append('dokumen_pendukung', this.form.dokumen_pendukung);
            }

            const response = await fetch(this.$store.state.url.REGIS_DONOR + "addData", {
               method: 'POST',
               headers: {
                  authorization: "kikensbatara " + localStorage.token
               },
               body: formData
            });

            const result = await response.json();

            if (response.ok && result.success) {
               this.$q.notify({
                  type: 'positive',
                  message: result.message || 'Data pendonor berhasil ditambahkan!'
               });

               this.resetForm();
               this.mdl_add = false;
               this.getView();
            } else {
               throw new Error(result.message || 'Terjadi kesalahan saat menambah data');
            }
         } catch (error) {
            console.error('Error adding data:', error);
            this.$q.notify({
               type: 'negative',
               message: error.message || 'Gagal menambah data pendonor!'
            });
         } finally {
            this.btn_add = false;
         }
      },

      editModal(data) {
         this.form = {
            id: data.id,
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            tanggal_lahir: data.tanggal_lahir || '',
            jenis_kelamin: data.jenis_kelamin || '',
            email: data.email || '',
            no_hp: data.no_hp || '',
            golongan_darah: data.golongan_darah || '',
            rhesus: data.rhesus || '',
            kabupaten_id: data.kabupaten_id || null,
            kecamatan_id: data.kecamatan_id || null,
            des_kel_id: data.des_kel_id || null,
            alamat: data.alamat || '',
            riwayat_penyakit: data.riwayat_penyakit || null,
            terakhir_donor: data.terakhir_donor || null,
            foto_profil: null,
            dokumen_pendukung: null,
            foto_profil_url: data.foto_profil ? (this.file_path + data.foto_profil) : '',
            dokumen_pendukung_url: data.dokumen_pendukung ? (this.file_path + data.dokumen_pendukung) : '',
            stokdarah_konut: data.stokdarah_konut || 4,
            bersedia_dipublikasikan: data.bersedia_dipublikasikan || true,
         };


         if (this.form.kabupaten_id) {
            this.loadKecamatan(this.form.kabupaten_id);
            if (this.form.kecamatan_id) {
               this.loadDeskel(this.form.kecamatan_id);
            }
         }

         this.mdl_edit = true;
      },

      async updateData() {
         this.btn_edit = true;
         try {
            if (!this.form.nama_lengkap || !this.form.tanggal_lahir || !this.form.jenis_kelamin || !this.form.golongan_darah) {
               throw new Error('Field wajib (Nama, TTL, Jenis Kelamin, Golongan Darah) harus diisi!');
            }

            if (this.form.nik && this.form.nik.length < 16) {
               throw new Error('NIK harus berjumlah 16 angka!');
            }
            const normalizedTerakhirDonor = this.normalizeDate(this.form.terakhir_donor);
            const normalizedTanggalLahir = this.normalizeDate(this.form.tanggal_lahir);
            const payload = {
               id: this.form.id,
               nama_lengkap: this.form.nama_lengkap,
               nik: this.form.nik,
               tanggal_lahir: normalizedTanggalLahir,
               jenis_kelamin: this.form.jenis_kelamin,
               email: this.form.email || '',
               no_hp: this.form.no_hp || '',
               golongan_darah: this.form.golongan_darah,
               rhesus: this.form.rhesus || '',
               kabupaten_id: this.form.kabupaten_id || null,
               kecamatan_id: this.form.kecamatan_id || null,
               des_kel_id: this.form.des_kel_id || null,
               alamat: this.form.alamat || '',
               riwayat_penyakit: this.form.riwayat_penyakit || '',
               terakhir_donor: normalizedTerakhirDonor,
               stokdarah_konut: this.form.stokdarah_konut || 4,
               bersedia_dipublikasikan: this.form.bersedia_dipublikasikan ? 1 : 0,
            };

            const hasNewFile = (this.form.foto_profil && this.form.foto_profil instanceof File) ||
               (this.form.dokumen_pendukung && this.form.dokumen_pendukung instanceof File);

            let response, result;

            if (hasNewFile) {
               const formData = new FormData();
               for (const key in payload) {
                  formData.append(key, payload[key] || '');
               }
               // Append files jika ada
               if (this.form.foto_profil && this.form.foto_profil instanceof File) {
                  formData.append('foto_profil', this.form.foto_profil);
               }
               if (this.form.dokumen_pendukung && this.form.dokumen_pendukung instanceof File) {
                  formData.append('dokumen_pendukung', this.form.dokumen_pendukung);
               }

               response = await fetch(this.$store.state.url.REGIS_DONOR + "editData", {
                  method: "POST",
                  headers: {
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: formData
               });
               result = await response.json();
            } else {
               response = await fetch(this.$store.state.url.REGIS_DONOR + "editData", {
                  method: "POST",
                  headers: {
                     "Content-Type": "application/json",
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: JSON.stringify(payload)
               });
               result = await response.json();
            }

            if (response.ok && result.success) {
               this.$q.notify({
                  type: "positive",
                  message: result.message || "Data pendonor berhasil diupdate"
               });

               this.mdl_edit = false;
               this.getView();
               this.resetForm();
            } else {
               throw new Error(result.message || "Gagal mengupdate data pendonor");
            }
         } catch (error) {
            console.error("Error update data pendonor:", error);
            this.$q.notify({
               type: "negative",
               message: error.message || "Terjadi kesalahan saat update data pendonor"
            });
         } finally {
            this.btn_edit = false;
         }
      },

      resetForm() {
         this.form = {
            id: null,
            nama_lengkap: '',
            nik: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            golongan_darah: '',
            rhesus: '',
            kabupaten_id: null,
            kecamatan_id: null,
            des_kel_id: null,
            alamat: '',
            email: '',
            no_hp: '',
            riwayat_penyakit: '',
            terakhir_donor: '',
            foto_profil: null,
            dokumen_pendukung: null,
            foto_profil_url: '',
            dokumen_pendukung_url: '',
            stokdarah_konut: 4,
            bersedia_dipublikasikan: true,
         };

         this.kecamatanOptions = [];
         this.deskelOptions = [];
         this.errorMessage = '';
      },

      async hapusData() {
         // Validasi ID wajib
         if (!this.form.id) {
            this.$q.notify({
               type: 'negative',
               message: 'Data tidak valid. Silakan pilih ulang.'
            });
            this.resetHapusForm();
            return;
         }

         this.btn_hapus = true;
         try {
            const payload = {
               id: this.form.id,

            };

            const response = await fetch(this.$store.state.url.REGIS_DONOR + "removePendonor", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify(payload)
            });

            const res_data = await response.json();

            if (response.ok && res_data.success) {
               this.$q.notify({
                  type: 'positive',
                  message: res_data.message || 'Data pendonor berhasil dihapus'
               });
               this.mdl_hapus = false;
               this.getView();
               this.resetForm();
            } else {
               throw new Error(res_data.message || 'Gagal menghapus data');
            }
         } catch (error) {
            console.error('Error hapus data:', error);
            this.$q.notify({
               type: 'negative',
               message: error.message || 'Terjadi kesalahan saat menghapus data'
            });
         } finally {
            this.btn_hapus = false;
         }
      },



      selectData(data) {

         this.errorMessage = '';
         this.form = {
            ...data,

            id: data.id
         };
         this.lihatData = {
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            tanggal_lahir: data.tanggal_lahir || '',
            jenis_kelamin: data.jenis_kelamin || '',
            golongan_darah: data.golongan_darah || '',
            rhesus: data.rhesus || '',
            email: data.email || '',
            no_hp: data.no_hp || '',
            alamat: data.alamat || '',
            riwayat_penyakit: data.riwayat_penyakit || '',
            terakhir_donor: data.terakhir_donor || '',
            kabupaten_nama: data.kabupaten_nama || '',
            kecamatan_nama: data.kecamatan_nama || '',
            des_kel_nama: data.des_kel_nama || '',
            foto_profil: data.foto_profil || '',
            dokumen_pendukung: data.dokumen_pendukung || '',

            id: data.id || '',
         };
      },

      resetHapusForm() {
         this.form.id = null;
         this.btn_hapus = false;
         this.mdl_hapus = false;
      },



      indexing(idx) {
         return ((this.page_first - 1) * this.page_limit) + idx;
      },

      normalizeDate(dateStr) {
         if (!dateStr || dateStr === '') return '';
         if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
         if (dateStr.includes('T')) return dateStr.split('T')[0];
         return '';
      },

      cari_data() { this.page_first = 1; this.getView(); },
      openFoto() {
         if (this.lihatData.foto_profil) {
            const url = this.file_path + this.lihatData.foto_profil;
            window.open(url, '_blank');
         } else {
            this.$q.notify({ type: 'negative', message: 'Foto tidak tersedia' });
         }
      },
      openDokumen() {
         if (this.lihatData.dokumen_pendukung) {
            const url = this.file_path + this.lihatData.dokumen_pendukung;
            window.open(url, '_blank');
         } else {
            this.$q.notify({ type: 'negative', message: 'Dokumen tidak tersedia' });
         }
      },
      handleImageError(event) {
         event.target.src = 'path/to/placeholder-image.jpg';  // Ganti dengan URL placeholder default, atau kosongkan src
         // Atau: event.target.style.display = 'none'; untuk sembunyikan img rusak
      },

      async openRiwayat(pendonor) {
         this.currentPendonor = pendonor || {};
         this.riwayatList = [];
         this.mdl_riwayat = true;
         this.riwayatLoading = true;

         const pendonorId = pendonor?.id || pendonor?.pendonor_id;
         if (!pendonorId) {
            this.$q.notify({ type: 'negative', message: 'ID pendonor tidak ditemukan' });
            this.riwayatLoading = false;
            return;
         }

         try {
            const res = await fetch(this.$store.state.url.REGIS_DONOR + "getHistoryByPendonor", {
               method: "POST",
               headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({ pendonor_id: pendonorId })
            });

            const json = await res.json();
            if (json.success && Array.isArray(json.data)) {
               this.riwayatList = json.data;
            } else {
               this.$q.notify({ type: 'warning', message: 'Tidak ada riwayat donor ditemukan' });
            }
         } catch (err) {
            console.error("❌ Error openRiwayat:", err);
            this.$q.notify({ type: 'negative', message: 'Gagal memuat riwayat donor' });
         } finally {
            this.riwayatLoading = false;
         }
      }




   },
   mounted() {
      this.getView();
      this.loadKabupaten();
   }
}
